import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import { useTranslation } from "react-i18next";
import { withAutoLogin } from "shared/constants/linkTo";

export const NotificationLMSLessonScheduled: FC<{item: any}> = ({item}) => {
    const {
        actions,
    } = item;
    const { t, i18n } = useTranslation()

    const scheduledInfo = actions[0]?.fieldValues;
    const lessonLink = scheduledInfo["lessonLink"] || scheduledInfo["LessonLink"];
    const lessonName_ru = scheduledInfo["lessonName_ru"] || scheduledInfo["LessonName_ru"];
    const lessonName_en = scheduledInfo["lessonName_en"] || scheduledInfo["LessonName_en"];
    const ThemeLink = scheduledInfo["themeLink"] || scheduledInfo["ThemeLink"];
    const themeName_ru = scheduledInfo["themeName_ru"] || scheduledInfo["ThemeName_ru"];
    const themeName_en = scheduledInfo["themeName_en"] || scheduledInfo["ThemeName_en"];
    const startDate = scheduledInfo["startDate"] || scheduledInfo["StartDate"];
    const startTime = scheduledInfo["startTime"] || scheduledInfo["StartTime"];
    const endTime = scheduledInfo["endTime"] || scheduledInfo["EndTime"];

    if (!scheduledInfo) return null;

    return <SimpleTitle>
        <a href={withAutoLogin(lessonLink)}>
            {i18n.language === 'ru' ? `${lessonName_ru} - ${themeName_ru}` : `${lessonName_en} - ${themeName_en}`}
            {' - '}
            {t('notifications.lms_date_scheduled', { startDate, startTime, endTime })}
        </a>     
    </SimpleTitle>
}import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import { useTranslation } from "react-i18next";
import { withAutoLogin } from "shared/constants/linkTo";

export const NotificationLMSLessonScheduled: FC<{item: any}> = ({item}) => {
    const {
        actions,
    } = item;
    const { t, i18n } = useTranslation()

    const scheduledInfo = actions[0]?.fieldValues;
    const lessonLink = scheduledInfo["lessonLink"] || scheduledInfo["LessonLink"];
    const lessonName_ru = scheduledInfo["lessonName_ru"] || scheduledInfo["LessonName_ru"];
    const lessonName_en = scheduledInfo["lessonName_en"] || scheduledInfo["LessonName_en"];
    const ThemeLink = scheduledInfo["themeLink"] || scheduledInfo["ThemeLink"];
    const themeName_ru = scheduledInfo["themeName_ru"] || scheduledInfo["ThemeName_ru"];
    const themeName_en = scheduledInfo["themeName_en"] || scheduledInfo["ThemeName_en"];
    const startDate = scheduledInfo["startDate"] || scheduledInfo["StartDate"];
    const startTime = scheduledInfo["startTime"] || scheduledInfo["StartTime"];
    const endTime = scheduledInfo["endTime"] || scheduledInfo["EndTime"];

    if (!scheduledInfo) return null;

    return <SimpleTitle>
        <a href={withAutoLogin(lessonLink)}>
            {i18n.language === 'ru' ? `${lessonName_ru} - ${themeName_ru}` : `${lessonName_en} - ${themeName_en}`}
            {' - '}
            {t('notifications.lms_date_scheduled', { startDate, startTime, endTime })}
        </a>     
    </SimpleTitle>
}